<template>
    <div>
        <input type="number"  placeholder="输入签约支付金额" v-model="signPriceVal" @keydown="changeKey" @input="getPriceVal" class="signPrices" @mousewheel='scrollFunc()' @DOMMouseScroll='scrollFunc()'/><span>&nbsp;元</span>   
    </div>
</template>
<script>
export default {
    props:['signatoryId','curIndex','amount'],
    data(){
        return {
            signPriceVal:""
        }
    },
    methods:{
        getPriceVal(){
            if(this.signPriceVal!=''){
                if(this.signPriceVal.indexOf('.')!=-1){
                    this.$emit("setPrcieVal",{id:this.signatoryId,amount:(this.signPriceVal-0).toFixed(2),ind:this.curIndex})
                }else{
                    this.$emit("setPrcieVal",{id:this.signatoryId,amount:this.signPriceVal,ind:this.curIndex})
                }
            }else{
                this.$emit("setPrcieVal",{id:this.signatoryId,amount:'',ind:this.curIndex})
            }
        },
        scrollFunc(evt) {  
            evt = evt || window.event;  
                if(evt.preventDefault) {  
                // Firefox  
                evt.preventDefault();  
                evt.stopPropagation();  
                } else {  
                // IE  
                evt.cancelBubble=true;  
                evt.returnValue = false;  
            }  
            return false;  
            },
            changeKey(e){
                if(e.keyCode==38 || e.keyCode==40){
                    if(e.preventDefault) {  
                        // Firefox  
                        e.preventDefault();  
                        e.stopPropagation();  
                        } else {  
                        // IE  
                        e.cancelBubble=true;  
                        e.returnValue = false;  
                    }
                }
            }
    },
    mounted(){
        this.signPriceVal=this.amount+'';
        this.getPriceVal();
    },
    watch:{
        'amount'(data){
            this.signPriceVal=this.amount+'';
            this.getPriceVal();
        }
    }
}
</script>
<style scoped lang="scss">
.signPrices{
   border: 1px solid #E4E8EB;
   border-radius: 2px;
   width: 108px;
   text-align: center;
   height: 28px;
   box-shadow: none;
   -moz-appearance:textfield;
}
.signPrices::-webkit-outer-spin-button,
.signPrices::-webkit-inner-spin-button{
    -webkit-appearance: none !important;
    margin: 0; 
}
</style>